import {
    Box,
    Typography,
    IconButton,
    List,
    ListItem,
    ListItemButton,
    ListItemText,
    ListItemIcon,
    Chip,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PersonIcon from '@mui/icons-material/Person';
import NotificationsIcon from '@mui/icons-material/Notifications';
import LogoutIcon from '@mui/icons-material/Logout';
import LockIcon from '@mui/icons-material/Lock';

// Mobile Navigations-Drawer.
function NavDrawer({ title, isLoggedIn, nutzer, navItems, onNav, onNavClick, onLogout, onClose }) {
    return (
        <Box sx={{ width: 280, bgcolor: 'background.paper', height: '100%' }}>
            <Box sx={{ p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="h6" fontWeight={700}>
                    {title}
                </Typography>
                <IconButton onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            </Box>

            {isLoggedIn && (
                <Box
                    sx={{ px: 2, py: 1.5, bgcolor: 'background.default', mx: 2, borderRadius: 2, mb: 2, display: "flex", justifyContent: "space-between" }}
                    onClick={() => onNav('/profil')}
                >
                    <Box>
                        <Box display="flex" alignItems="center" gap={1}>
                            <PersonIcon color="primary" />
                            <Typography variant="body1" fontWeight={600}>
                                {nutzer ? nutzer.vname || nutzer.email : 'Gast'}
                            </Typography>
                        </Box>
                        <Typography variant="body2" color="text.secondary">
                            {nutzer ? nutzer.email : 'Keine E-Mail'}
                        </Typography>
                    </Box>
                </Box>
            )}

            {isLoggedIn && (
                <ListItem disablePadding>
                    <ListItemButton onClick={() => onNav("/einladungen")}>
                        <ListItemIcon><NotificationsIcon /></ListItemIcon>
                        <ListItemText>Benachrichtigungen</ListItemText>
                    </ListItemButton>
                </ListItem>
            )}

            <List>
                {navItems.map((item) => {
                    const isLocked = false; // item.premiumRequired && !isPremium;
                    return (
                        <ListItem key={item.label} disablePadding>
                            <ListItemButton
                                onClick={() => onNavClick(item)}
                                sx={{ opacity: isLocked ? 0.5 : 1 }}
                            >
                                <ListItemIcon>
                                    {isLocked ? <LockIcon sx={{ fontSize: 16, color: 'text.disabled' }} /> : item.icon}
                                </ListItemIcon>
                                <ListItemText primary={item.label} />
                                {isLocked && (
                                    <Chip
                                        label="PRO"
                                        size="small"
                                        sx={{
                                            height: 18,
                                            fontSize: 10,
                                            bgcolor: 'rgba(59, 130, 246, 0.12)',
                                            color: 'primary.main',
                                            border: '1px solid',
                                            borderColor: 'primary.main',
                                        }}
                                    />
                                )}
                            </ListItemButton>
                        </ListItem>
                    );
                })}

                {isLoggedIn && (
                    <ListItem disablePadding>
                        <ListItemButton onClick={onLogout}>
                            <ListItemIcon>
                                <LogoutIcon color="error" />
                            </ListItemIcon>
                            <ListItemText primary="Logout" />
                        </ListItemButton>
                    </ListItem>
                )}
            </List>
        </Box>
    );
}

export default NavDrawer;
